import React from 'react';

import { Box, Typography } from '@mui/material';

import { EMPTY_VALUE } from './ticketRiskRows';

interface Props {
  label: string;
  children: React.ReactNode;
}

/**
 * True when every part of the value is blank or a dash. Empty fields are common — most
 * tickets carry no authority mention or LLM risk factor — so they are dimmed rather than
 * competing with the fields that do say something.
 */
function isEmptyValue(children: React.ReactNode): boolean {
  if (Array.isArray(children)) {
    return children.every(isEmptyValue);
  }

  return children == null || children === '' || children === EMPTY_VALUE;
}

/** One caption-over-value cell in the ticket detail dialog's grids. */
export default function DetailField({ label, children }: Props) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography sx={{ overflowWrap: 'anywhere' }} color={isEmptyValue(children) ? 'text.disabled' : undefined}>
        {children}
      </Typography>
    </Box>
  );
}
